// extracted by mini-css-extract-plugin
export default {"root":"Circle_root__DNVxi","success":"Circle_success__Zg1nv","error":"Circle_error__TnESf","placeHolderShimmer":"Circle_placeHolderShimmer__VbZUC"};